import { render, staticRenderFns } from "./DeleteJobModal.vue?vue&type=template&id=68bc1d5b&scoped=true&class=fill-height&"
import script from "./DeleteJobModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteJobModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteJobModal.vue?vue&type=style&index=0&id=68bc1d5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc1d5b",
  null
  
)

export default component.exports